import React from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { notificationsAccessControl } from '../access-control/notificationsAccess.configuration'
import { NotificationSettings } from '../pages/list/settings/NotificationSettings'
// @hygen:inject page-import

// Partner Scoped Routes
export const notificationsSettingsRouter = (
  <DomainRoute route="notifications-settings" accessControl={notificationsAccessControl}>
    <DashSwitch>
      <DomainRoute route="notifications-settings" component={NotificationSettings} />
    </DashSwitch>
  </DomainRoute>
)
